import { useInstance } from '@meraki-internal/react-dependency-injection';
import { IQueryParamDrivenDrawerContentProvider } from '../components/query-param-driver-drawer/IQueryParamDrivenDrawerContentProvider';
import { QueryParamDrivenDrawerHelper } from '../components/query-param-driver-drawer/QueryParamDrivenDrawerHelper';
import { StructuredRecordEditorDrawer } from './structured-records/StructuredRecordEditorDrawer';
import { DiagnosisDescriptor } from './DiagnosisDescriptor';
import { DiagnosisFormState } from './DiagnosisFormState';

interface IDiagnosisEditorDrawerProps {
    id: string;
}

export class DiagnosisEditorDrawer implements IQueryParamDrivenDrawerContentProvider<IDiagnosisEditorDrawerProps> {
    static inject = () => [QueryParamDrivenDrawerHelper];
    constructor(private drawerHelper: QueryParamDrivenDrawerHelper<IDiagnosisEditorDrawerProps>){}

    mode = 'edit-diagnosis';

    Component = DiagnosisEditorDrawerView;

    open = (props: IDiagnosisEditorDrawerProps) => {
        this.drawerHelper.open({ mode: this.mode, ...props });
    };

    buildQueryParams = (props: IDiagnosisEditorDrawerProps) => {
        return this.drawerHelper.buildQueryParams({ mode: this.mode, id: props.id });
    };
}

const DiagnosisEditorDrawerView: React.FC<IDiagnosisEditorDrawerProps> = ({ id }) => {
    const descriptor = useInstance(DiagnosisDescriptor);
    const formState = useInstance(DiagnosisFormState);

    return (
        <StructuredRecordEditorDrawer
            descriptor={descriptor}
            formState={formState}
            id={id}
        />
    );
};
